import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sub_page_con wrap_1120 report_area" }
const _hoisted_2 = { class: "btn_wrap _default right_btn _adm_btn" }
const _hoisted_3 = { class: "sub_con_banner" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "btn_wrap _default float_right _board_type in_line" }
const _hoisted_6 = {
  key: 0,
  class: "btn_wrap _default float_right _board_type in_line"
}
const _hoisted_7 = { class: "select_tab_box _board_type" }
const _hoisted_8 = { class: "tab_option" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "list_table con_board sub_page_con_view areaList" }
const _hoisted_11 = { class: "thead_li" }
const _hoisted_12 = { class: "tr_div con_tit" }
const _hoisted_13 = {
  key: 0,
  class: "tb_chk checkbox_wrap2"
}
const _hoisted_14 = { class: "tr_div con_tit" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "tb_no no_768" }
const _hoisted_17 = { class: "tb_subject" }
const _hoisted_18 = { class: "tb_part" }
const _hoisted_19 = { class: "tb_date_hour" }
const _hoisted_20 = {
  key: 2,
  class: "_flex _jc_sb _flex_100"
}
const _hoisted_21 = { class: "_flex info_wrap" }
const _hoisted_22 = { class: "ws_nowrap" }
const _hoisted_23 = { class: "po_ab" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalReportBanner = _resolveComponent("ModalReportBanner")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($setup.state.hasAuth && !$setup.state.isMobile)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "common_btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openGuideModal && $setup.openGuideModal(...args)))
            }, "안내글 수정하기"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          innerHTML: $setup.CommonUtils.decodeContent($setup.state.menuContent)
        }, null, 8, _hoisted_4),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "link con_list" }, [
          _createElementVNode("p", null, "시민제보 처리과정이 궁금하신가요? "),
          _createElementVNode("a", {
            href: "#faqView/27",
            class: "action_btn",
            target: "_blank"
          }, [
            _createElementVNode("span", null, "과정 보러가기"),
            _createElementVNode("img", {
              src: "img/move_btn.png",
              alt: ""
            })
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!$setup.state.hasAuth)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "common_btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/areaWrite')))
            }, "제보하기"))
          : _createCommentVNode("", true)
      ]),
      ($setup.state.hasAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "common_btn _gray",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
            }, "삭제"),
            (!$setup.state.isMobile)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "icon_wrap",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.downloadFile && $setup.downloadFile(...args)))
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("img", {
                    src: "img/excel_icon.png",
                    alt: "엑셀 다운로드"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["selected_tab", [$setup.state.isShowSearchType ? 'active' : '']]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.state.isShowSearchType = !$setup.state.isShowSearchType))
        }, [
          _createElementVNode("span", null, _toDisplayString($setup.state.detailTxt), 1)
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.search_type_list, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              onClick: ($event: any) => {
                        $setup.state.detailType = item.key;
                        $setup.state.detailTxt = item.value;
                        $setup.state.isShowSearchType = false;
                        $setup.getList();
                    }
            }, _toDisplayString(item.value), 9, _hoisted_9))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              ($setup.state.hasAuth)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.checkAll) = $event)),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleAll()))
                    }, null, 544), [
                      [_vModelCheckbox, $setup.state.checkAll]
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("em", null, null, -1))
                  ]))
                : _createCommentVNode("", true),
              _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"tb_no no_768\">번호</div><div class=\"tb_ans\">상태</div><div class=\"tb_subject\">제목</div><div class=\"tb_part\">분류</div><div class=\"tb_date_hour\">날짜</div>", 5))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.list, (item, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "tbody_li",
              key: item.idx
            }, [
              _createElementVNode("div", _hoisted_14, [
                ($setup.state.hasAuth)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tb_chk checkbox_wrap2",
                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.checkedList) = $event)),
                        value: item.idx,
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, _hoisted_15), [
                        [_vModelCheckbox, $setup.state.checkedList]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                _createElementVNode("div", {
                  class: _normalizeClass($setup.state.hasAuth ? 'tb_ans adm_login' : 'tb_ans')
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([item.state === 1 ? 'ans_yet' : 'ans_complete'])
                  }, _toDisplayString(item.state === 1 ? "대기중" : "접수완료"), 3)
                ], 2),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AreaView', params: { id: item.idx } },
                    class: "elips_1"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("성매매 의심업소 제보", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ]),
                (!$setup.state.isMobile)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.isSchool === 1 ? "학교주변" : "의심업소"), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                        _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mo_th" }, "분류", -1)),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.isSchool === 1 ? "학교주변" : "의심업소"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                    ]))
              ])
            ]))
          }), 128))
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 1,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalReportBanner, {
      isShow: $setup.state.isShowGuideModal,
      title: '성매매 의심업소 제보 안내글 수정',
      type: 1,
      onClose: $setup.closeModal
    }, null, 8, ["isShow", "onClose"]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}